import Script from "next/script"
import { Card } from 'react-bootstrap'
import HtmlText from 'atoms/html-text'
import ExternalCssSheet from "atoms/external-css-sheet"

export default function LuckyWpTableOfContents({ 
    html,
    sticky = false,
}) {
    return (
      <div className={`${sticky ? 'sticky' : ''}-toc`}>
        <Script
          src={`${process.env.NEXT_PUBLIC_API_URL}/wp-content/plugins/luckywp-table-of-contents/front/assets/main.min.js?ver=2.1.4`}
          strategy="afterInteractive"
          onReady={() => window.lwptoc?.globalInit()}
        />
        <ExternalCssSheet
          uniqueKey="lwtoc-css"
          href={`${process.env.NEXT_PUBLIC_API_URL}/wp-content/plugins/luckywp-table-of-contents/front/assets/main.min.css?ver=2.1.4`}
        />
        <Card>
          <Card.Header>Inhoudsopgave</Card.Header>
          <Card.Body className="p-0">
            <HtmlText body={html} />
          </Card.Body>
        </Card>

        <style jsx>{`
          .sticky-toc {
            position: -webkit-sticky; /* Safari */
            position: sticky;
            top: 110px;
          }

          @media screen and (min-width: 992px) and (max-width: 1199px) {
            .sticky-toc {
              top: 150px;
            }
          }
        `}</style>
      </div>
    )
}
